module.exports = __webpack_public_path__ + "static/img/logo9.e7d0312.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solutions/logo9.png
// module id = vAR5
// module chunks = 0